module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-11.dfa6ddbc.png";